import React, { useContext, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";
import moment from "moment";
import { PageBody } from "../../components/loader";
import { useLoadingMessage } from "../../components/useLoadingMessage";

import { muchAndLearnMngtThunk } from "../../store/actions/trainingmanagement/training.thunk";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";

export const Dashboard = () => {
  const [theme, setTheme] = useState({});
  const { user, refresh } = useContext(AuthContext);
  const { isLoading, message, updateLoader } = useLoadingMessage();
  // console.log("date", user.data.user.last_login);
  const alert = useAlert();
  const { themeOfTheWeek } = useSelector((state) => state.trainingMngt);
  const dispatch = useDispatch();

  const getThemeOfTheWeek = useCallback(async () => {
    updateLoader(true, "Loading");
    await dispatch(muchAndLearnMngtThunk.getAllThemeOfTheWeek());
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    setTheme(themeOfTheWeek[0]);
  }, [themeOfTheWeek]);

  useEffect(() => {
    getThemeOfTheWeek();
  }, []);
  return (
    <PageBody isLoading={isLoading} message={message}>
      <div className="content">
        <div className="container-fluid">
          <div className="row page-title-box">
            <div className="col-md-5">
              <div className="float-left pl-3 mb-3">
                <h4 className="page-title"></h4>
                <h1 className="welcome_text">
                  <small>
                    WELCOME <br></br>
                    {user.data.user.first_name + " " + user.data.user.last_name}
                  </small>
                </h1>
                <p className="text-white">
                  <em>
                    Last Login :{" "}
                    {moment(user.data.user.last_login)
                      .add(1, "hour")
                      .startOf("minutes")
                      .fromNow()}
                  </em>
                </p>
                <p className="text-white">
                  <em>From : {user.data.user.last_login_ip}</em>
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="float-right">
                <h4 className="welcome_text">
                  <small>THEME OF THE WEEK</small>
                </h4>
                <h2 className="pr-3"> {theme && theme.theme}</h2>
                <p className="text-white pr-3">{theme && theme.name}</p>
              </div>

              <div className="clearfix"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-3 col-sm-6">
              {" "}
              <Link to="/dashboard/employee">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span>EMPLOYEE</span>
                    </h2>
                    <p className="">MANAGEMENT</p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-sm-6">
              <Link to="/dashboard/organization">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span></span> <span>ORGANIZATION</span>
                    </h2>
                    <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                      MANAGEMENT
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-sm-6">
              <Link to="/dashboard/holiday">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span></span> <span>HOLIDAY</span>
                    </h2>
                    <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                      MANAGEMENT
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-sm-6">
              <Link to="/dashboard/office-structure">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span></span> <span>OFFICE</span>
                    </h2>
                    <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                      STRUCTURE
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6">
              <Link to="/dashboard/performance">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span></span> <span>PERFORMANCE</span>
                    </h2>
                    <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                      MANAGEMENT
                    </p>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-sm-6">
              <Link to="/dashboard/training">
                <div className="card-box widget-box-two widget-two-custom">
                  <div className="wigdet-two-content">
                    <h2 className="font-600">
                      <span></span> <span>TRAINING</span>
                    </h2>
                    <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                      MANAGEMENT
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            {(user.data.user.roles && user.data.user.roles.name === "admin") ||
            user.data.user.roles.name === "human resource" ? (
              <div className="col-xl-3 col-sm-6">
                <Link to="/dashboard/report">
                  <div className="card-box widget-box-two widget-two-custom">
                    <div className="wigdet-two-content">
                      <h2 className="font-600">
                        <span></span> <span> REPORT </span>
                      </h2>
                      <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                        MANAGEMENT
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : null}
            {user.data.user.roles && user.data.user.roles.name === "admin" ? (
              <div className="col-xl-3 col-sm-6">
                <Link to="/dashboard/pending">
                  <div className="card-box widget-box-two widget-two-custom">
                    <div className="wigdet-two-content">
                      <h2 className="font-600">
                        <span></span> <span> PENDING </span>
                      </h2>
                      <p className="m-0 text-uppercase font-bold font-secondary text-overflow">
                        REQUEST
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/index.js